import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#d6ff63' },
    secondary: { main: '#6c862c' },
  },
});

export default theme;
